import { orderBy } from "lodash";
import { CommodityType, MarketViewProductModel } from "../../../Generated/Mark-It-View-Api";
import { useListResource, useLoadingState } from "../../../Hooks";
import { StoneXAutocomplete } from "../../StoneXMui";
import { useEffect, useState } from "react";
import { CircularProgress, IconButton } from "@mui/material";
import { MarkItViewApi } from "../../../Apis/Apis";
import { Star, StarBorder } from "@mui/icons-material";
import { LoadingState } from "../../../Types";


interface MarkItViewProductSelector {
  commodityType?: CommodityType | null;
  initialProductId?: number | null;
  errors?: string;
  minProductHistoryYears?: number;
  lastQuoteDateThresholdDays?: number;
  onProductChange?: (product: MarketViewProductModel | null) => void;
  onProductsLoaded?: (products: MarketViewProductModel[]) => void;
}

export default function MarkItViewProductSelector(props: MarkItViewProductSelector) {

  const { commodityType, errors, minProductHistoryYears, lastQuoteDateThresholdDays, onProductChange, onProductsLoaded } = props;

  // ToDo: Should be using the loading state from the list resource. But it is not working at the moment.
  const productsLoadingState = useLoadingState();

  const [initialProductId, setInitialProductId] = useState<number | undefined | null>(props.initialProductId);
  const products = useListResource<MarketViewProductModel, number>([], null, (item) => item.productId);
  const [productsUpdating, setProductsUpdating] = useState<{ [key: number]: boolean }>({});
  
  function loadProducts(commodityType: CommodityType): Promise<void> {
    const promise = MarkItViewApi.listMarketViewProducts(productsLoadingState.setLoadingState, commodityType, undefined, minProductHistoryYears, lastQuoteDateThresholdDays).then((response) => {
      if (response.data.rows) {
        products.setItems(response.data.rows);   
        onProductsLoaded?.(response.data.rows);

        if (initialProductId) {
          const selectedProduct = response.data.rows.find((product) => product.productId === initialProductId);
          if (selectedProduct) {
            products.setSelectedItem(selectedProduct);
            internalOnUpdate(selectedProduct);
          }
          setInitialProductId(null);
        }
      }
    });

    return promise;
  };

  function toggleFavorite(product: MarketViewProductModel){
    product.isFavorite = !product.isFavorite;

    const callback = () => {
      const newSet = [...products.items.filter((q) => q.productId != product.productId), product];
      products.setItems(newSet);
      setProductsUpdating((previous) => ({ ...previous, [product.productId]: false }));
    };

    const savedFailedCallback = () => {
      setProductsUpdating((previous) => ({ ...previous, [product.productId]: false }));
    };

    if (product.isFavorite) {
      setProductsUpdating((previous) => ({ ...previous, [product.productId]: true }));
      MarkItViewApi.addMarketViewUserFavoritedProduct(null, String(product.productId)).then(callback).catch(savedFailedCallback);
    } else {
      setProductsUpdating((previous) => ({ ...previous, [product.productId]: true }));
      MarkItViewApi.deleteMarketViewUserFavoritedProduct(null, String(product.productId)).then(callback).catch(savedFailedCallback);
    }
  };

  function internalOnUpdate(product: MarketViewProductModel | null) {
    if (product) {
      products.setSelectedItem(product);
      onProductChange?.(product);
    } else {
      products.setSelectedItem(null);
      onProductChange?.(null);
    }
  }

  useEffect(() => {

    if (commodityType) {
      loadProducts(commodityType);
    }

    products.setLoadingState(LoadingState.None);
    products.setItems([]);

  }, [commodityType]);

  return <>
    <StoneXAutocomplete
      options={orderBy(products.items, [(product) => product.commodityType, (product) => product.name])}
      getOptionLabel={(product) => product.name}
      key={'productId'}
      dropdownAutoWidth
      value={products.selectedItem}
      onUpdate={internalOnUpdate}
      loading={productsLoadingState.isLoading}
      listKey={'productId'}
      label="Products"
      error={errors}
      disableClearable
      dropdownWidth={500}
      renderOption={(props, product) => (
        <li {...props} key={product.productId}> 
        <IconButton
        onClick={(e: any) => {
        e.stopPropagation();
        toggleFavorite(product);
        }}
        sx={{ padding: 0, margin: 0, marginRight: '8px' }}
        >
        {productsUpdating[product.productId] ? <CircularProgress size="1em" /> : product.isFavorite ? <Star /> : <StarBorder />}
        </IconButton>
              {product.name}{product.commodityType == "EUNaturalGas" || product.commodityType == "EUElectricity" ? ` - ${product.currency} - ${product.unit}` : ''} 
        </li>
      )}
    />
  </>
}